/* eslint-disable */
import api from '@/utils/backend-api'

export default {
  namespaced: true,
  state: {
    adminpackages: ''
  },
  mutations: {
    setPackageData (state, adminpackages) {
      state.adminpackages = adminpackages
    },
    reset (state) {
      state.adminpackages = ''
    }

  },
  actions: {
    getAllPackages ({commit}) {
      api.getData('admin/package').then(res => {
        var packages = res.data
        commit('setPackageData', packages)
      })
    },
    createPackage ({commit}, PackageDetails) {
      return new Promise(function(resolve,reject){
        api.postData('admin/package/create', PackageDetails).then(res => {
          if(res.status==201){
            resolve(res)
          }
        })
      })
    },
    getPackageById ({commit}, id) {
      if (id) {
        api.getData('admin/package/' + id).then(
        res => {
          var packages = res.data
          commit('setPackageData', packages)
        })
      }
    },
    packageEdit ({commit}, Data) {
      return new Promise(function (resolve, reject) {
        api.postData('admin/package/' + Data.packId, Data.PackageDetails).then(res => {
          commit('setPackageData', res.Data)
          resolve(res.Data)
        }).catch((error) => {
        reject(error)
        })
        .then(() => {
        })
    })
  }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Packages.js